export default __webpack_public_path__ + "static/media/zarya-barrierally.7239bac8.mp3";